<template>
  <div class="pagination">
    <button class="previous pagination-button" @click="prevPage" :disabled="currentPage === 1" aria-label="Forrige slide">
      <svg class="icon caret-right" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
           fill="none">
        <path d="M6.71094 18L14.7109 10L6.71094 2L5.29427 3.41667L11.8776 10L5.29427 16.5833L6.71094 18Z"
              fill="currentColor"/>
      </svg>
    </button>

    <span v-for="(item, index) in paginationRange" :key="index">
      <button
          v-if="typeof item === 'number'"
          class="pagination-button"
          :class="{ 'current-page': item === currentPage }"
          @click="$emit('update:currentPage', item)"
      >
        {{ item }}
      </button>
      <span v-else class="pagination-dots">...</span>
    </span>

    <button class="next pagination-button" @click="nextPage" :disabled="currentPage === totalPages" aria-label="Næste slide">
      <svg class="icon caret-right" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
           fill="none">
        <path d="M6.71094 18L14.7109 10L6.71094 2L5.29427 3.41667L11.8776 10L5.29427 16.5833L6.71094 18Z"
              fill="currentColor"/>
      </svg>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  totalPages: {
    type: Number,
    required: true
  },
  currentPage: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['update:currentPage'])

const paginationRange = computed(() => {
  const total = props.totalPages
  const current = props.currentPage
  const range = []
  let addedDots = false

  for (let i = 1; i <= total; i++) {
    const isEdge = i === 1 || i === total
    const isNearCurrent = i >= current - 1 && i <= current + 1

    if (isEdge || isNearCurrent) {
      range.push(i)
      addedDots = false
    } else if (!addedDots) {
      range.push('...')
      addedDots = true
    }
  }
  return range
})

function prevPage() {
  if (props.currentPage > 1) {
    emit('update:currentPage', props.currentPage - 1)
  }
}

function nextPage() {
  if (props.currentPage < props.totalPages) {
    emit('update:currentPage', props.currentPage + 1)
  }
}
</script>
